import React, { useEffect, useState } from 'react';
import { A } from 'hookrouter';
import { getValues, format, FilterList } from '../tables/shared/FormatDetails';
import { useTranslation } from 'react-i18next';
import { EMPLOYEE_DETAILS_NO_BILLING_INFO, MONTH, HOURS, EMPLOYEE_DETAILS_INVOICE_LABEL, EMPLOYEE_DETAILS_AMOUNT_LABEL } from '../../i18n/keyConstants';

const EmployeeInvoiceInfo = ({ invoiceInfo, startDate, endDate }) => {
    const [invoices, setInvoices] = useState();
    const [searchValue, setSearchValue] = useState('');
    const { t } = useTranslation(['employeeDetails']);


    useEffect(() => {
        if (invoiceInfo && invoiceInfo.length) {
            const sortedInvoices = invoiceInfo.sort((a, b) => {
                return a - b;
            });

            setInvoices(FilterList(sortedInvoices, startDate, endDate));
        }
    }, [invoiceInfo, startDate, endDate]);

    const getResults = (consultant, invoiceInformation) => {
        const results = getValues(consultant, invoiceInformation);
        return results;
    };

    return (
        <div>
            {invoices && invoices.length > 0 ? (
                <div className='padding-top-30px'>
                    <div className='d-flex justify-content-between col-12 col-lg-10 offset-lg-1 employee-invoice padding-none'>
                        <table className='table table-striped table-sm mob font'>
                            <thead>
                                <tr>
                                    <th className='hiddenCol padding-left-10px'>{t(MONTH, { ns: 'shared' })}</th>
                                    <th>
                                        <input
                                            className='th-filter w-100'
                                            type='text'
                                            placeholder='Kund'
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                    </th>
                                    <th className='text-right'>{t(HOURS, {ns: 'shared'})}</th>
                                    <th className='text-right'>{t(EMPLOYEE_DETAILS_AMOUNT_LABEL)}</th>
                                    <th className='padding-right-10px padding-left-10px text-right'>{t(EMPLOYEE_DETAILS_INVOICE_LABEL)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getResults(searchValue, invoices).filtered.map((inv, i) => (
                                    <tr key={i}>
                                        <td className='padding-left-10px hiddenCol'>{inv.invoiceMon}</td>
                                        <td>
                                            {inv.invoiceCustomer !== '' ? (
                                                <A href={`/customer/${inv.cstId}`}>{inv.invoiceCustomer}</A>
                                            ) : (
                                                inv.invoiceCustomer
                                            )}
                                        </td>
                                        <td className='text-right hours'>{inv.invoiceHours ? format(inv.invoiceHours, 1) : ''}</td>
                                        <td className='text-right'>{inv.invoiceAmount ? format(inv.invoiceAmount, 1) : ''} </td>
                                        <td className='padding-right-10px padding-left-10px invoice-number text-right'>
                                            {inv.invoiceNumber}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='divider-sum'>
                                <tr>
                                    <td className='showCol'></td>
                                    <td className='hiddenCol' colSpan='1'></td>
                                    <td className='font-weight-bold text-right hours'>
                                        {invoices ? getResults(searchValue, invoices).sumHours : ''}
                                    </td>
                                    <td className='font-weight-bold mr-2 text-right'>
                                        {invoices ? getResults(searchValue, invoices).sumAmount : ''}
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            ) : (
                <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 padding-top-30px'>
                        <p className='text-center'>{t(EMPLOYEE_DETAILS_NO_BILLING_INFO)}</p>
                </div>
            )}
        </div>
    );
};
export default EmployeeInvoiceInfo;
